import { atom } from "recoil";      
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist({
    key:'addressInputDisableState',
    storage:sessionStorage,
});
// nftjsonからmeta除いて取得した連想配列の状態を,ブラウザ上に永続的(タブが消されない限り)保持する Atoms を作成。
export const addressInputDisableState = atom({
    key: "addressInputDisableState",
    default:false,
    effects_UNSTABLE:[persistAtom],
});